import React, { useState, useEffect } from 'react';
import { Typography, Input, Button, Icon } from '../../kit';
import { themeColors as defaultThemeColors } from '../../theme/theme';
import { etext } from './constants';
import { useTranslation } from '@/kit/useTranslation';

function InlineEditableField({
  label,
  value,
  onSave,
  validate,
  inputProps = {},
  startAdornment,
  type = 'text',
  themeColors,
}) {
  const tc = { ...defaultThemeColors, ...themeColors };
  const { t } = useTranslation();
  const [editValue, setEditValue] = useState(value || '');
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setEditValue(value || '');
  }, [value]);

  const handleSave = async () => {
    const err = validate ? validate(editValue) : '';
    setError(err);
    if (err) return;
    await onSave(editValue);
    setEditing(false);
  };

  return (
    <div>
      <div
        style={{
          borderBottom: `1px solid ${tc.profileBorder}`,
          padding: '12px 0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            type="body1"
            text={label}
            style={{ flex: 1, color: tc.profileText, fontWeight: 500 }}
          />
          {editing ? (
            <div style={{ flex: 2, marginLeft: 12 }}>
              <Input
                value={editValue}
                onChange={(e) => {
                  setEditValue(e.target.value);
                  setError(validate ? validate(e.target.value) : '');
                }}
                error={!!error}
                helperText={error ? t(etext[error]) : ''}
                size="small"
                type={type}
                startAdornment={startAdornment}
                inputProps={inputProps}
              />
            </div>
          ) : (
            <div
              style={{
                flex: 2,
                marginLeft: 12,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {startAdornment}
              <Typography type="body2" text={value || '-'} style={{ color: tc.profileMuted }} />
            </div>
          )}
          <Icon
            name={editing ? 'Close' : 'EditOutlined'}
            style={{
              color: editing ? tc.profileMuted : tc.pendingColor,
              fontSize: 20,
              cursor: 'pointer',
              marginLeft: 12,
            }}
            onClick={() => setEditing(!editing)}
          />
        </div>
      </div>
      {editing && (
        <div style={{ display: 'flex', gap: 8, marginTop: 8, marginLeft: 12 }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            disabled={!!error || editValue === value}
          >
            {t('common.save')}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setEditing(false);
              setEditValue(value || '');
              setError('');
            }}
          >
            {t('common.cancel')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default InlineEditableField;
